import { Metadata } from 'next';

export const siteConfigCN = {
  title: 'Decodo',
  description: 'Decodo官方网站。',
  url: 'https://decodo.cn',
};

export const noFollowExclusionsCN = [
  'decodo.cn',
  'help.decodo.cn'
];

export const metadataCN: Metadata = {
  verification: {
    other: {
      'baidu-site-verification': 'codeva-uE8n4zTezG',
    },
  },
};
